import React, { useMemo } from 'react';
import './student-onboarding-fall-2023.css'
import SearchHeader from '../SearchHeader/SearchHeader';
import { FilterTypeId } from '../SearchHeader/filters-type';
import axios from 'axios';
import _ from "lodash";
import { baseUrl } from '../assets/Animations';
import {BsThreeDotsVertical} from 'react-icons/bs'
import { FinishedLady } from './assets/FinishedLady';
import { getRequestHeaders } from '../api';
import StudentOnboardingTaskCard2023 from './StudentOnboardingTaskCard2023/StudentOnboardingTaskCard2023';
import ConfettiZoneStudentOnboarding from './ConfettiZoneStudentOnboarding';
import ModalDropdownMenuFall2023 from '../StudentOnboardingCardModalFall2023/ModalAreaFall2023/ModalDropdownMenuFall2023/ModalDropdownMenuFall2023';
import ManuallyAddStudentPopup from './ManuallyAddStudentPopup/ManuallyAddStudentPopup';
import { buildDefaultTeacherOnboardingTemplate, createTeacherOnboardingWorkflow, TEACHER_ONBOARDING_TEMPLATE_ID } from '../AdminWorkflows/WorkflowModels';
import NewTeacherCardModal from './NewTeacherCardModal/NewTeacherCardModal';
import WorkflowTemplateModal from '../AdminTasks/WorkflowTemplateModal/WorkflowTemplateModal';
import {
    buildDefaultStudentWorkflowTemplate,
    getStudentWorkflowTemplateConfig,
} from './studentWorkflowTemplateConfig';
import SummerBreakSummaryModal from './SummerBreakSummary/SummerBreakSummaryModal';
import { buildSummerBreakSummary } from './SummerBreakSummary/summerBreakSummaryUtils';
import {
    buildDuplicateInquiryInfoByFamilyId,
    shouldShowDuplicateInquiryWarning,
} from './duplicateInquiryUtils';
import ReturningFamilyMergeModal from './ReturningFamilyMergeModal/ReturningFamilyMergeModal';
import {
    getStudentWorkflowCardFromPacket,
    upsertStudentWorkflowCard,
} from './studentOnboardingRealtimeUtils';
import {
    buildTeacherAssignmentFilterOptions,
    matchesTeacherAssignmentFilter,
} from './teacherAssignmentUtils';


const StudentOnboardingFall2023 = ({
        setStudentOnboardingModal, 
        rawStudentOnboardingCards,
        setRawStudentOnboardingCards,
        studentOnboardingCards, 
        setStudentOnboardingCards,
        isConfettiExplosion,
        setIsConfettiExplosion,
        socket,
        userData,
        studentOnboardingCardsInUse,
        setStudentOnboardingCardsInUse
    }) => {

    const [schools, setSchools] = React.useState([]);
    //const [calendarEvents, setCalendarEvents] = React.useState([]);
    const [filterState, setFilterState] = React.useState({school: 'all'});
    const [openDropdown, setOpenDropdown] = React.useState(false);
    const [manuallyAddStudentPopup, setManuallyAddStudentPopup] = React.useState(false);
    const [labels, setLabels] = React.useState({});
    const [displayWaitlist, setDisplayWaitlist] = React.useState(true);
    const [displaySummerBreakPeople, setDisplaySummerBreakPeople] = React.useState(false);
    const [summerBreakSummaryOpen, setSummerBreakSummaryOpen] = React.useState(false);
    const [summerBreakSummaryLoading, setSummerBreakSummaryLoading] = React.useState(false);
    const [summerBreakSummaryError, setSummerBreakSummaryError] = React.useState('');
    const [summerBreakSummary, setSummerBreakSummary] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [showSchoolsOnCards, setShowSchoolsOnCards] = React.useState(true);
    const [toolTip, setToolTip] = React.useState(false);
    const [teachers, setTeachers] = React.useState([]);
    const [familiesForDuplicateCheck, setFamiliesForDuplicateCheck] = React.useState([]);
    const [nameQuery, setNameQuery] = React.useState("");
    const [newTeacherCardModal, setNewTeacherCardModal] = React.useState(false);
    const [creatingTeacherCard, setCreatingTeacherCard] = React.useState(false);
    const [teacherWorkflowTemplateModal, setTeacherWorkflowTemplateModal] = React.useState(false);
    const [editTeacherWorkflowTemplate, setEditTeacherWorkflowTemplate] = React.useState(false);
    const [studentWorkflowTemplateModal, setStudentWorkflowTemplateModal] = React.useState(false);
    const [editStudentWorkflowTemplate, setEditStudentWorkflowTemplate] = React.useState(false);
    const [studentWorkflowTemplateLoading, setStudentWorkflowTemplateLoading] = React.useState('');
    const [studentWorkflowTemplateError, setStudentWorkflowTemplateError] = React.useState('');
    const [familyMergeRequest, setFamilyMergeRequest] = React.useState(null);
    const hasLoadedBoardRef = React.useRef(false);
    const hasInitializedRef = React.useRef(false);

    const onboardingColumns = [
        {
            title: 'TEACHER LEAVING',
            filterName: 'leaving',
            dropDownMenuOptions: [
                {
                    label: displayWaitlist ? 'Hide' : 'Show',
                    onClick: () => setDisplayWaitlist(!displayWaitlist)
                },
                {
                    label: displaySummerBreakPeople ? 'Hide Summer Break Students' : 'Show Summer Break Students',
                    onClick: () => setDisplaySummerBreakPeople(!displaySummerBreakPeople)
                },
                {
                    label: 'Summer Break Summary',
                    accent: true,
                    onClick: () => openSummerBreakSummary()
                },
            ],
            total: true
        },
        // {
        //     title: 'WAITLIST',
        //     filterName: 'waitlist',
        //     dropDownMenuOptions: [
        //         {
        //             label: displayWaitlist ? 'Hide' : 'Show',
        //             onClick: () => setDisplayWaitlist(!displayWaitlist)
        //         },
        //     ],
        //     total: true
        // },
        // {
        //     title: 'INQUIRIES',
        //     filterName: 'inquiry',
        //     dropDownMenuOptions: [
        //         {
        //             label: '+ New Student (Default)',
        //             onClick: () => setManuallyAddStudentPopup(['New Student', 'inquiry'])
        //         },
        //         {
        //             label: '+ Reassign',
        //             onClick: () => setManuallyAddStudentPopup(['Reassign', 'inquiry'])
        //         },
        //         {
        //             label: '+ Old Student',
        //             onClick: () => setManuallyAddStudentPopup(['Old Student', 'inquiry'])
        //         }
        //     ],
        //     total: false
        // },
        {
            title: 'SCHEDULING',
            filterName: 'scheduling',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'scheduling'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'scheduling'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'scheduling'])
                },
                {
                    label: 'Edit Template',
                    accent: true,
                    onClick: () => openStudentWorkflowTemplateEditor('scheduling')
                }
            ],
            total: true
        },
        {
            title: 'INTRO LESSON',
            filterName: 'intro',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'intro'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'intro'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'intro'])
                },
                {
                    label: 'Edit Template',
                    accent: true,
                    onClick: () => openStudentWorkflowTemplateEditor('intro')
                }
            ],
            total: true
        },
        {
            title: 'ONBOARDING',
            filterName: 'onboarding',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'onboarding'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'onboarding'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'onboarding'])
                },
                {
                    label: 'Edit Template',
                    accent: true,
                    onClick: () => openStudentWorkflowTemplateEditor('onboarding')
                }
            ],
            total: true
        },
        {
            title: 'TEACHER ONBOARDING',
            filterName: 'teacher',
            dropDownMenuOptions: [
                {
                    label: '+ New Teacher',
                    onClick: () => setNewTeacherCardModal(true)
                },
                {
                    label: 'Edit Workflow',
                    onClick: () => openTeacherWorkflowTemplateEditor()
                }
            ],
            total: false
        }
    ]

    React.useEffect(() => {
        if (hasInitializedRef.current) return
        hasInitializedRef.current = true
        makeCalls();
        startInquirySmsTracking();
        userData.PermissionLevel === 'manager' && setFilterState({school: userData.School.toLowerCase()})
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                clickBackOnCalls()
            }
          };
      
          // Add the event listener to the document
          document.addEventListener('visibilitychange', handleVisibilityChange);
      
          // Clean up the event listener when the component unmounts
          return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
          };
    }, [])

    React.useEffect(() => {
        setOpenDropdown(false)
    },[displayWaitlist])

    React.useEffect(() => {
        highlightAlreadyInUseCards()
    }, [studentOnboardingCardsInUse])

    React.useEffect(() => {
        const handleStudentWorkflowUpdate = (packet) => {
            const updatedCard = getStudentWorkflowCardFromPacket(packet)
            if (!updatedCard || packet?.emitter === userData.Name) return

            setRawStudentOnboardingCards((previous) =>
                upsertStudentWorkflowCard(previous, updatedCard)
            )
            setStudentOnboardingCards((previous) =>
                upsertStudentWorkflowCard(previous, updatedCard)
            )
        }

        const handleStudentWorkflowCreate = (packet) => {
            const newCard = getStudentWorkflowCardFromPacket(packet)
            if (!newCard) {
                console.warn('Ignored malformed createStudentWorkflow event:', packet)
                return
            }

            if(packet?.emitter !== userData.Name) {
                setRawStudentOnboardingCards((previous) =>
                    upsertStudentWorkflowCard(previous, newCard)
                )
                setStudentOnboardingCards((previous) =>
                    upsertStudentWorkflowCard(previous, newCard)
                )
            }
            moveCardAnimation(newCard.todoId)
        }

        const handleStudentWorkflowOpen = (packet) => {
            const emitter = packet?.emitter
            const cardId = packet?.data ?? (typeof packet === 'string' ? packet : null)
            if(emitter && emitter !== userData.Name && cardId) {
                setLabels(prev => ({...prev, [cardId]: emitter}))
            }
        }

        const handleStudentWorkflowSave = (packet) => {
            const updatedPacket = packet?.updatedCard
            const updatedCard = getStudentWorkflowCardFromPacket(updatedPacket)
            if (!updatedCard) return

            if(updatedPacket?.emitter !== userData.Name) {
                //remove the todoId key value pair from labels
                setLabels((previous) => {
                    const labelsCopy = {...previous}
                    delete labelsCopy[updatedCard.todoId]
                    return labelsCopy
                })
                setRawStudentOnboardingCards((previous) =>
                    upsertStudentWorkflowCard(previous, updatedCard)
                )
                setStudentOnboardingCards((previous) =>
                    upsertStudentWorkflowCard(previous, updatedCard)
                )
                setStudentOnboardingCardsInUse((previous) => (
                    Array.isArray(previous)
                        ? previous.filter((card) => card?.data !== updatedCard.todoId)
                        : []
                ))
            }
            moveCardAnimation(updatedCard.todoId)
        }

        const handleStudentWorkflowDelete = (packet) => {
            const cardId = packet?.data ?? (typeof packet === 'string' ? packet : null)
            if(packet?.emitter !== userData.Name && cardId) {
                setLabels((previous) => {
                    const labelsCopy = {...previous}
                    delete labelsCopy[cardId]
                    return labelsCopy
                })
                setRawStudentOnboardingCards(prev => prev.filter(flow => flow?.todoId !== cardId))
                setStudentOnboardingCards(prev => prev.filter(flow => flow?.todoId !== cardId))
            }
        }

        socket.on('createStudentWorkflow', handleStudentWorkflowCreate)
        socket.on('openStudentWorkflow', handleStudentWorkflowOpen)
        socket.on('closeAndSaveStudentWorkflow', handleStudentWorkflowSave)
        socket.on('updateStudentWorkflow', handleStudentWorkflowUpdate)
        socket.on('closeAndDeleteStudentWorkflow', handleStudentWorkflowDelete)

        return () => {
            socket.off('createStudentWorkflow', handleStudentWorkflowCreate)
            socket.off('openStudentWorkflow', handleStudentWorkflowOpen)
            socket.off('closeAndSaveStudentWorkflow', handleStudentWorkflowSave)
            socket.off('updateStudentWorkflow', handleStudentWorkflowUpdate)
            socket.off('closeAndDeleteStudentWorkflow', handleStudentWorkflowDelete)
        }
    }, [
        setRawStudentOnboardingCards,
        setStudentOnboardingCards,
        setStudentOnboardingCardsInUse,
        socket,
        userData.Name,
    ])

    React.useEffect(() => {
        if(filterState.school === 'all' || !filterState.school) {
            setShowSchoolsOnCards(true)
        } else {
            setShowSchoolsOnCards(false)
        }
    }, [filterState.school])

    React.useEffect(() =>
          isConfettiExplosion &&
          setTimeout(() => {
            setIsConfettiExplosion(false);
          }, 5000)
    , [isConfettiExplosion]);

    const moveCardAnimation = (id) => {
        setTimeout(() => {
            if(!document.getElementById(id)) {return}
            document.getElementById(id).style.animation = 'cardMoveAttentionFlash 500ms'
            document.getElementById(id).style.animationTimingFunction = 'ease'
            document.getElementById(id).style.border = '1px solid orange'
            setTimeout(() => {
                document.getElementById(id).style.border = '1px solid #fff'
            }, 1000);
        }, 0)
    }

    const fetchTeachers = React.useCallback(async () => {
        try {
            const teacherResponse = await axios.get(`${baseUrl}/initialadminrequest`, getRequestHeaders())
            setTeachers(Array.isArray(teacherResponse.data) ? teacherResponse.data : [])
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchFamiliesForDuplicateCheck = React.useCallback(async () => {
        try {
            const familyResponse = await axios.get(
                `${baseUrl}/school-management`,
                getRequestHeaders()
            )
            setFamiliesForDuplicateCheck(
                Array.isArray(familyResponse?.data) ? familyResponse.data : []
            )
        } catch (error) {
            console.error('Unable to check onboarding cards for duplicate emails:', error)
        }
    }, [])

    const refreshFamiliesAfterMerge = React.useCallback(async () => {
        await fetchFamiliesForDuplicateCheck()
    }, [fetchFamiliesForDuplicateCheck])

    const fetchBoardData = React.useCallback(async () => {
        try {
            setLoading(true)
            const schoolParam =
                userData.PermissionLevel === 'manager'
                    ? userData.School.toLowerCase()
                    : 'all'

            const [boardReturn, teacherWorkflowReturn] = await Promise.all([
                axios.get(`${baseUrl}/student-onboarding-board`, {
                    ...getRequestHeaders(),
                    params: {
                        school: schoolParam,
                        includeSummerBreak: displaySummerBreakPeople
                    }
                }),
                axios.get(`${baseUrl}/onboarding`, getRequestHeaders())
            ])

            const boardCards = Array.isArray(boardReturn?.data?.cards) ? boardReturn.data.cards : []
            const teacherCards = Array.isArray(teacherWorkflowReturn?.data)
                ? teacherWorkflowReturn.data.filter((card) => card?.whichList === 'teacher')
                : []
            const boardSchools = Array.isArray(boardReturn?.data?.schools) ? boardReturn.data.schools : []
            const mergedCards = [...boardCards]

            teacherCards.forEach((teacherCard) => {
                if (!mergedCards.some((card) => card.todoId === teacherCard.todoId)) {
                    mergedCards.push(teacherCard)
                }
            })

            setRawStudentOnboardingCards(mergedCards)
            setStudentOnboardingCards(mergedCards)
            setSchools(boardSchools.length > 0 ? boardSchools : [
                { id: 'all', label: 'All Schools' },
                { id: 'mma', label: 'Mountainside' },
                { id: 'lsma', label: 'Lakeside' },
                { id: 'tma', label: 'Treeside' },
                { id: 'mor', label: 'Morningside' },
                { id: 'psma', label: 'Parkside' },
                { id: 'den', label: 'Denton' },
                { id: 'tem', label: 'Tempe' },
                { id: 'tul', label: 'Tulsa' }
            ])
            hasLoadedBoardRef.current = true
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    }, [
        displaySummerBreakPeople,
        setRawStudentOnboardingCards,
        setStudentOnboardingCards,
        userData.PermissionLevel,
        userData.School
    ])



    const makeCalls = async () => {
        await Promise.all([
            fetchBoardData(),
            fetchTeachers(),
            fetchFamiliesForDuplicateCheck(),
        ])
    };

    const startInquirySmsTracking = async () => {
        try {
            await axios.post(
                `${baseUrl}/inquiry-sms-activity/tracking-start`,
                {},
                getRequestHeaders()
            )
        } catch (error) {
            console.error('Unable to initialize inquiry SMS response tracking:', error)
        }
    }


    const clickBackOnCalls = async () => {
        await Promise.all([
            fetchBoardData(),
            fetchFamiliesForDuplicateCheck(),
        ])
    }

    React.useEffect(() => {
        if (!hasLoadedBoardRef.current) return
        fetchBoardData()
    }, [displaySummerBreakPeople, fetchBoardData])

    // const checkIfIntroLessonHasHappened = (card) => {
    //     if(card.hasIntroHappened) {return card}
    //     //if the card is in the onboarding column
    //     if(card.whichList === 'onboarding') {
    //     //if the card has a familyId
    //         if(card.familyId) {
    //             for(let i = 0; i < calendarEvents.length; i++) {
    //                 let event = calendarEvents[i]
    //                 if(event.familyId === card.familyId) {
    //                     if(!event.isPendingOffer) {
    //                         const dateIsWithinInterval = isWithinInterval(new Date(event.dateTime),{ start: subWeeks(new Date(), 1), end: new Date() })
    //                         if(dateIsWithinInterval && checkIfEmailTaskIsDone(card)) {
    //                             card.hasIntroHappened = false
    //                             return card
    //                         } else if (dateIsWithinInterval && !checkIfEmailTaskIsDone(card)) {
    //                             card.hasIntroHappened = 'follow-up'
    //                             return card
    //                         }
    //                     }
    //             }
    //         }
    //         }
    //         card.hasIntroHappened = false
    //         return card
    //     }
    // }

    const filteredCards = React.useMemo(() => {
        const nameFilter = nameQuery.toString().toLocaleLowerCase()
        const selectedSchools = (filterState.school === 'all' || !filterState.school) ? null : filterState.school
        const selectedInstruments = filterState.instrument
        const selectedTeachers = filterState.teacher

        const safeCards = Array.isArray(rawStudentOnboardingCards)
            ? rawStudentOnboardingCards.filter((card) => card && typeof card === 'object')
            : []

        return safeCards.filter((card) => {
            const teachName = String(card?.todoName || '').toLocaleLowerCase()
            const nameMatch = !nameFilter || teachName.includes(nameFilter)
            const cardSchool = String(card?.whichSchool || '').toLowerCase()

            const schoolMatch =
                !selectedSchools ||
                selectedSchools.length === 0 ||
                selectedSchools.includes(cardSchool)

            const instrumentMatch =
                !selectedInstruments ||
                selectedInstruments.length === 0 ||
                (Array.isArray(card?.studentList) && card.studentList.some((student) =>
                    (Array.isArray(student?.instrumentList) ? student.instrumentList : []).some((instrument) =>
                        selectedInstruments.includes(instrument?.id)
                    )
                ))

            const teacherMatch = matchesTeacherAssignmentFilter(card, selectedTeachers)

            return nameMatch && instrumentMatch && schoolMatch && teacherMatch
        })
    }, [
        filterState.instrument,
        filterState.school,
        filterState.teacher,
        nameQuery,
        rawStudentOnboardingCards,
    ])

    const cardsByColumn = React.useMemo(() => {
        const grouped = {}
        const getSortableDateValue = (value) => {
            const parsed = new Date(value).getTime()
            return Number.isNaN(parsed) ? 0 : parsed
        }

        onboardingColumns.forEach((column) => {
            grouped[column.filterName] = []
        })

        filteredCards.forEach((card) => {
            if(displayWaitlist === false && card.whichList === 'waitlist') {
                return
            }

            if (grouped[card.whichList]) {
                grouped[card.whichList].push(card)
            }

            if (
                card.whichList === 'student' &&
                (filterState.school === 'all' || !filterState.school || card.whichSchool.toLowerCase() === filterState.school)
            ) {
                grouped.scheduling = grouped.scheduling || []
                grouped.scheduling.push(card)
            }
        })

        Object.keys(grouped).forEach((list) => {
            if(list === 'intro') {
                grouped[list].sort((a, b) => getSortableDateValue(a.todoDueDate) - getSortableDateValue(b.todoDueDate))
            } else if (list === 'leaving') {
                grouped[list].sort((a, b) => new Date(b.leavingDate) - new Date(a.leavingDate))
            } else {
                grouped[list].sort((a, b) => getSortableDateValue(b.todoDueDate) - getSortableDateValue(a.todoDueDate))
            }
        })

        return grouped
    }, [displayWaitlist, filteredCards, filterState.school, onboardingColumns])

    const duplicateInquiryInfoByFamilyId = React.useMemo(
        () => buildDuplicateInquiryInfoByFamilyId(familiesForDuplicateCheck),
        [familiesForDuplicateCheck]
    )

    // const formatFamilyIntoCardForWaitlist = (family) => {
    //     let card = {
    //         todoId: family.familyId,
    //         todoName: family.familyStatus === 'Waitlist' ? `${family.familyName}` : findWaitlistStudentandReturnName(family),
    //         todoDescription: '',
    //         familyId: family.familyId,
    //         studentList: family.students,
    //         todoDueDate: new Date(),
    //         todoAlarm: false,
    //         theyHaveBeenCalled: false,
    //         todoOwner: '',
    //         waitlistEntity: assessTheFamiliesWaitlistStatus(family),
    //         whoIsOnWaitlist: family.familyStatus === 'Waitlist' ? 'Family' : 'Student',
    //         whichList: 'waitlist',
    //         whichSchool: family.school.toLowerCase(),
    //         todoSubtasks: []
    //       }
    //       return card
    // }

    // const assessTheFamiliesWaitlistStatus = (family) => {
    //     let listOfWaitlistLabelAndIdPairs = [];
    //     let listOfWaitlistEntities = [];
    //     //Find if family is on waitlist and if the students are on the waitlist
    //     if(family.familyStatus === 'Waitlist') {
    //         listOfWaitlistLabelAndIdPairs.push(['Family', family.familyId])
    //         for(let i = 0; i < family.students.length; i++) {
    //             if(family.students[i].studentStatus === 'Waitlist') {
    //                 listOfWaitlistLabelAndIdPairs.push(['Student', family.students[i].studentId])
    //             }
    //         }
    //     } else {
    //         for(let i = 0; i < family.students.length; i++) {
    //             if(family.students[i].studentStatus === 'Waitlist') {
    //                 listOfWaitlistLabelAndIdPairs.push(['Student', family.students[i].studentId])
    //             }
    //         }
    //     }
    //     //get all the waitlist entities
    //     listOfWaitlistLabelAndIdPairs.forEach((pair) => {
    //         let entity = checkForWaitlistEntitiesForFamily(pair)
    //         entity && listOfWaitlistEntities.push(entity)
    //     })
    //     //find the oldest waitlist entity in the array
    //     let oldestWaitlistEntity = listOfWaitlistEntities[0];
    //     for(let i = 1; i < listOfWaitlistEntities.length; i++) {
    //         if(listOfWaitlistEntities[i].startDate < oldestWaitlistEntity.startDate) {
    //             oldestWaitlistEntity = listOfWaitlistEntities[i];
    //         }
    //     }
    //     return oldestWaitlistEntity ? oldestWaitlistEntity : null;
    // }

    const highlightAlreadyInUseCards = () => {
        for(let i = 0; i < studentOnboardingCards.length; i++) {
            if(document.getElementById(studentOnboardingCards[i].todoId)) {
                document.getElementById(studentOnboardingCards[i].todoId).style.border = "none"
                document.getElementById(`user-${studentOnboardingCards[i].todoId}`).style.display = 'none'
            }
        }
        for(let i = 0; i < rawStudentOnboardingCards.length; i++) {
            if(document.getElementById(rawStudentOnboardingCards[i].todoId)) {
                document.getElementById(rawStudentOnboardingCards[i].todoId).style.border = "none"
                document.getElementById(`user-${rawStudentOnboardingCards[i].todoId}`).style.display = 'none'
            }
        }
        for(let i = 0; i < studentOnboardingCardsInUse.length; i++) {
            if(document.getElementById(studentOnboardingCardsInUse[i].data)) {
                document.getElementById(studentOnboardingCardsInUse[i].data).style.border = "2px solid fuchsia"
                document.getElementById(`user-${studentOnboardingCardsInUse[i].data}`).style.padding = '2px'
                document.getElementById(`user-${studentOnboardingCardsInUse[i].data}`).style.display = 'inline-block'
            }
        }
    }

    const createASpecificCardForASpecificFamily = (familyId, column, typeOfCard, callback) => {
        axios.post(`${baseUrl}/create-student-onboarding-card/${familyId}/${column}/${typeOfCard}`, getRequestHeaders())
        .then(() => {
            fetchBoardData()
            callback(false)
        })
        .catch((err) => console.log(err))
    }

    const openNewTeacherCard = (trimmedTeacherName) => {
        setCreatingTeacherCard(true)
        const selectedSchool = Array.isArray(filterState.school)
            ? filterState.school[0]
            : filterState.school
        const userSchool =
            userData?.School && userData.School.toLowerCase() !== 'admin'
                ? userData.School.toLowerCase()
                : ''
        const teacherSchool =
            (selectedSchool && selectedSchool !== 'all' && selectedSchool) ||
            userSchool ||
            'mma'

        createTeacherOnboardingWorkflow(
            setLoading,
            (newCard) => {
                socket.emit('createStudentWorkflow', {emitter: userData.Name, data: newCard})
                setRawStudentOnboardingCards(prev => [...prev, newCard])
                setStudentOnboardingCards(prev => [...prev, newCard])
                setCreatingTeacherCard(false)
                setNewTeacherCardModal(false)
            },
            setStudentOnboardingModal,
            trimmedTeacherName,
            teacherSchool,
            () => setCreatingTeacherCard(false)
        )
    }

    const openTeacherWorkflowTemplateEditor = async () => {
        try {
            const templateResponse = await axios.get(`${baseUrl}/templates`, getRequestHeaders())
            const templates = Array.isArray(templateResponse.data) ? templateResponse.data : []
            const teacherTemplate = templates.find((template) => template.todoId === TEACHER_ONBOARDING_TEMPLATE_ID)

            if (teacherTemplate) {
                setEditTeacherWorkflowTemplate(true)
                setTeacherWorkflowTemplateModal(teacherTemplate)
            } else {
                setEditTeacherWorkflowTemplate(false)
                setTeacherWorkflowTemplateModal(buildDefaultTeacherOnboardingTemplate())
            }
        } catch (error) {
            if (error?.response?.status !== 401 && error?.response?.status !== 404) {
                console.log(error)
            }
            setEditTeacherWorkflowTemplate(false)
            setTeacherWorkflowTemplateModal(buildDefaultTeacherOnboardingTemplate())
        }
    }

    const openStudentWorkflowTemplateEditor = async (column) => {
        const config = getStudentWorkflowTemplateConfig(column)
        if (!config || studentWorkflowTemplateLoading) return

        setStudentWorkflowTemplateLoading(config.whichList)
        setStudentWorkflowTemplateError('')

        try {
            const response = await axios.get(
                `${baseUrl}/studentworkflowtemplates/${config.todoId}`,
                getRequestHeaders()
            )
            const savedTemplate = response?.data && typeof response.data === 'object'
                ? response.data
                : null

            if (savedTemplate) {
                setEditStudentWorkflowTemplate(true)
                setStudentWorkflowTemplateModal({
                    ...savedTemplate,
                    todoSubtasks: Array.isArray(savedTemplate.todoSubtasks)
                        ? savedTemplate.todoSubtasks
                        : [],
                })
            } else {
                setEditStudentWorkflowTemplate(false)
                setStudentWorkflowTemplateModal(buildDefaultStudentWorkflowTemplate(column))
            }
        } catch (error) {
            console.error('Unable to open student workflow template:', error)
            setStudentWorkflowTemplateError(
                `Unable to open the ${config.todoName}. Please try again.`
            )
        } finally {
            setStudentWorkflowTemplateLoading('')
        }
    }

    const openSummerBreakSummary = async () => {
        setSummerBreakSummaryOpen(true)
        setSummerBreakSummaryLoading(true)
        setSummerBreakSummaryError('')

        try {
            const managerSchool = userData.PermissionLevel === 'manager'
                ? String(userData.School || '').toLowerCase()
                : ''
            const boardSchool = managerSchool || 'all'
            const [boardResponse, familiesResponse, teachersResponse] = await Promise.all([
                axios.get(`${baseUrl}/student-onboarding-board`, {
                    ...getRequestHeaders(),
                    params: {
                        school: boardSchool,
                        includeSummerBreak: true,
                    },
                }),
                axios.get(`${baseUrl}/families-to-watch`, getRequestHeaders()),
                axios.get(`${baseUrl}/initialadminrequest`, getRequestHeaders()),
            ])

            const summaryCards = Array.isArray(boardResponse?.data?.cards)
                ? boardResponse.data.cards
                : []
            const summaryFamilies = Array.isArray(familiesResponse?.data)
                ? familiesResponse.data
                : []
            const summaryTeachers = Array.isArray(teachersResponse?.data)
                ? teachersResponse.data
                : []
            const summarySchools = Array.isArray(boardResponse?.data?.schools)
                ? boardResponse.data.schools
                : schools
            const schoolMatchesManager = (schoolValue) => (
                !managerSchool || String(schoolValue || '').toLowerCase() === managerSchool
            )

            setSummerBreakSummary(buildSummerBreakSummary({
                cards: summaryCards.filter((card) => schoolMatchesManager(card?.whichSchool)),
                families: summaryFamilies.filter((family) => schoolMatchesManager(family?.school)),
                teachers: summaryTeachers,
                schools: summarySchools.filter((school) => (
                    school?.id !== 'all' && schoolMatchesManager(school?.id)
                )),
            }))
        } catch (error) {
            console.error('Unable to load the summer break summary:', error)
            setSummerBreakSummaryError('Please check your connection and try again.')
        } finally {
            setSummerBreakSummaryLoading(false)
        }
    }


    const teacherFilterOptions = useMemo(() => {
        const managerSchool = userData.PermissionLevel === 'manager'
            ? userData.School
            : ''

        return buildTeacherAssignmentFilterOptions({
            teachers,
            cards: rawStudentOnboardingCards,
            schoolKey: managerSchool,
        })
    }, [rawStudentOnboardingCards, teachers, userData.PermissionLevel, userData.School])

    const filters = useMemo(() => [
        {
            id: "instrument",
            label: "Instrument",
            type: FilterTypeId.Dropdown,
            options:
              teachers &&
              _.uniqBy(
                teachers.reduce((acc, teacher) => {
                  return [
                    ...acc,
                    ...teacher.InstrumentList.map((instrument) => {
                      return {
                        id: instrument.id,
                        label: instrument.name,
                        group: instrument.instrumentGroup,
                      };
                    }),
                  ];
                }, []),
                (x) => x.id
              ),
          },
        {
            id: "teacher",
            label: "Teacher",
            type: FilterTypeId.Dropdown,
            options: teacherFilterOptions,
        },
        userData.PermissionLevel !== 'manager' && {
            id: "school",
            label: "School",
            type: FilterTypeId.SelectDropDown,
            options: schools ? schools : [],
          },
        ], [schools, teacherFilterOptions, teachers, userData.PermissionLevel]);

    const handleFilterChange = React.useCallback((nextFilterState) => {
        const nextFilters = nextFilterState && typeof nextFilterState === 'object'
            ? nextFilterState
            : {}

        setFilterState(
            userData.PermissionLevel === 'manager'
                ? {
                    ...nextFilters,
                    school: String(userData.School || '').toLowerCase(),
                }
                : nextFilters
        )
    }, [userData.PermissionLevel, userData.School])

    const openStudentOnboardingCard = (card) => {
        socket.emit('openStudentWorkflow', {emitter: userData.Name, data:card.todoId})
        setStudentOnboardingModal(card)
    }

    const isReassignmentCard = (card) => {
        return card?.todoDescription === 'Reassign' || card?.whichList === 'orange'
    }

    const isOldStudentCard = (card) => {
        return card?.todoDescription === 'Old Student' || card?.whichList === 'blue'
    }

    const calculateTotals = (list) => {
        let totalStudents = 0;
        let newStudents = 0;
        ;(cardsByColumn[list] || []).forEach((card) => {
            if(card.whichList === list) {
                totalStudents = totalStudents + card.studentList.length

                if(!isOldStudentCard(card) && !isReassignmentCard(card)) {
                    newStudents = newStudents + card.studentList.length
                }
            }
        })

        if(totalStudents === 0 && newStudents === 0) {
            return null
        }

        return `(${totalStudents}) (${newStudents} new)`
    }

    return (
        <div className='student-onboarding-fall-2023__wrapper'>
            <ReturningFamilyMergeModal
                mergeRequest={familyMergeRequest}
                onClose={() => setFamilyMergeRequest(null)}
                onMerged={refreshFamiliesAfterMerge}
            />
            <SummerBreakSummaryModal
                open={summerBreakSummaryOpen}
                loading={summerBreakSummaryLoading}
                error={summerBreakSummaryError}
                summary={summerBreakSummary}
                onClose={() => setSummerBreakSummaryOpen(false)}
                onRetry={openSummerBreakSummary}
            />
            <NewTeacherCardModal
                open={newTeacherCardModal}
                onClose={() => !creatingTeacherCard && setNewTeacherCardModal(false)}
                onSubmit={openNewTeacherCard}
                isSubmitting={creatingTeacherCard}
            />
            {teacherWorkflowTemplateModal && (
                <WorkflowTemplateModal
                    workflowTemplateModal2023={teacherWorkflowTemplateModal}
                    setWorkflowTemplateModal2023={setTeacherWorkflowTemplateModal}
                    editWorkflow={editTeacherWorkflowTemplate}
                    setEditWorkflow={setEditTeacherWorkflowTemplate}
                />
            )}
            {studentWorkflowTemplateModal && (
                <WorkflowTemplateModal
                    workflowTemplateModal2023={studentWorkflowTemplateModal}
                    setWorkflowTemplateModal2023={setStudentWorkflowTemplateModal}
                    editWorkflow={editStudentWorkflowTemplate}
                    setEditWorkflow={setEditStudentWorkflowTemplate}
                    templateResource='studentworkflowtemplates'
                />
            )}
            {studentWorkflowTemplateLoading && (
                <div className='student-onboarding-fall-2023__template-status is-loading'>
                    Opening {getStudentWorkflowTemplateConfig(studentWorkflowTemplateLoading)?.todoName}…
                </div>
            )}
            {studentWorkflowTemplateError && (
                <div className='student-onboarding-fall-2023__template-status is-error' role='alert'>
                    <span>{studentWorkflowTemplateError}</span>
                    <button type='button' onClick={() => setStudentWorkflowTemplateError('')}>
                        Dismiss
                    </button>
                </div>
            )}
            {manuallyAddStudentPopup && <ManuallyAddStudentPopup manuallyAddStudentPopup={manuallyAddStudentPopup} setManuallyAddStudentPopup={setManuallyAddStudentPopup} createASpecificCardForASpecificFamily={createASpecificCardForASpecificFamily} />}
            {/* {toolTip && <OnboardingToolTip2023 card={toolTip} calendarEvents={calendarEvents} />} */}
            <ConfettiZoneStudentOnboarding isConfettiExplosion={isConfettiExplosion} />
            <SearchHeader
                title="Student Onboarding"
                filters={filters}
                onChangeQuery={(string) => setNameQuery(string)}
                onChangeFilters={handleFilterChange}
                clearAll={true}
            />
            <div className='student-onboarding-fall-2023__columns-wrapper'>
                {onboardingColumns.map((column, index) => {
                    const columnCards = cardsByColumn[column.filterName] || []
                    const isTeacherColumn = column.filterName === 'teacher'
                    return <div key={index} className={`student-onboarding-fall-2023__column ${isTeacherColumn ? 'student-onboarding-fall-2023__column--teacher' : ''}`}>
                        <div className={`student-onboarding-fall-2023__column-title__area ${isTeacherColumn ? 'student-onboarding-fall-2023__column-title__area--teacher' : ''}`}>
                            <div className='student-onboarding-fall-2023__column-title'>{column.title} {column.total ? calculateTotals(column.filterName) : null}</div>
                            <BsThreeDotsVertical cursor={'pointer'} color='#94A3B8' onClick={() => setOpenDropdown(column.title)} />
                            {openDropdown === column.title && <ModalDropdownMenuFall2023 menuItems={column.dropDownMenuOptions} setOpenDropdown={setOpenDropdown} />}
                        </div>
                        {
                            loading && columnCards.length === 0 ?
                            <div className='student-onboarding-fall-2023__loading'>LOADING...</div>  
                        :
                            <div className={`student-onboarding-fall-2023__column-scroll-area ${isTeacherColumn ? 'student-onboarding-fall-2023__column-scroll-area--teacher' : ''}`} style={columnCards.length === 0 ? {backgroundColor: isTeacherColumn ? '#ECFDF5' : '#F1F5F9'} : {backgroundColor: isTeacherColumn ? '#F7FFFB' : 'rgb(248, 250, 252)'}}>
                            {columnCards.length > 0 ?
                                <div>
                                    {columnCards.map((card) => (
                                        <StudentOnboardingTaskCard2023
                                            key={card.todoId}
                                            labels={labels}
                                            card={card}
                                            showSchoolsOnCards={showSchoolsOnCards}
                                            setStudentOnboardingModal={openStudentOnboardingCard}
                                            setToolTip={setToolTip}
                                            teachers={teachers}
                                            duplicateInquiryInfo={
                                                shouldShowDuplicateInquiryWarning(card)
                                                    ? duplicateInquiryInfoByFamilyId[
                                                        String(card?.familyId || '').trim()
                                                    ]
                                                    : null
                                            }
                                            onReviewDuplicate={userData?.IsAdmin === true
                                                ? (selectedCard, duplicateInfo) => setFamilyMergeRequest({
                                                    currentFamilyId: String(selectedCard?.familyId || '').trim(),
                                                    duplicateInfo,
                                                })
                                                : null
                                            }
                                        />
                                    ))}
                                </div>
                                :
                                <div className='finished-lady__wrapper'>
                                    <FinishedLady />
                                </div>
                                }
                        </div>
                    }
                    </div>
                })}
            </div>
        </div>
    )
}
export default StudentOnboardingFall2023;
